import { useState, useEffect, createContext } from 'react';
import { STEPS } from './steps';
import CheckoutSummary from './CheckoutSummary';
import CartCompact from './CartCompact';
import ProductSelector from './ProductSelector';
import Cart from './Cart';
import Checkout from './Checkout';
import { includes, assign, orderBy, get, fromPairs, uniqBy, sumBy, filter, sortBy, concat, find, sum, map} from 'lodash';
import {SvgSimpleRemove2, SvgTailLeft1, TailLeftHeader} from "/components/shared/SvgIcons";
import { loadStripe } from '@stripe/stripe-js/pure';
import ShopMenu from './ShopMenu';
import { WidgetProvider } from './WidgetContext';
import Spinner from './Spinner';
import Link from "next/link";
import {useRouter} from 'next/router';


function ViewHeader({title, url}) {
    const router = useRouter();
    const handleCloseClick = (e) => {
        e.preventDefault();
        router.push(url);
    };

    return (
        <div className="flex justify-between px-2 py-2 w-full">
            <Link href={url}>
                <div className="inline-flex justify-center items-center cursor-pointer">
                    <div className='hidden xl:block'>{SvgTailLeft1()}</div>
                    <div className='xl:hidden'>{TailLeftHeader()}</div>
                    <a className="text-gold uppercase text-sm xl:text-md ml-2">
                        <h4>{title}</h4>
                    </a>
                </div>
            </Link>
            <div className="cursor-pointer" onClick={handleCloseClick}>{SvgSimpleRemove2()}</div>
        </div>
    );
}



export default function TicketWidget({ slug, ticketing_base_url }) {
    const [loading, setLoading] = useState(true);
    const [step, setStep] = useState(STEPS.PRODUCT_SELECTION);
    const [activeTab, setActiveTab] = useState('all');
    let view;
    if (loading) {
        view = (
            <div className="flex w-full h-full items-center justify-center">
              <div className="bg-blue-500 flex">
                <Spinner/> lade verfügbare Tickets...
              </div>
            </div>
        );
    } else {
        if (step === STEPS.PRODUCT_SELECTION) {
            view = (
                <>
                  <div className="p-4 lg:p-16 overflow-y-auto flex-1">
                    <Cart label={'Tickets'} showArticleCount={false} showTicketing={true}/>
                  </div>
                  <div className="w-full lg:w-1/3 bg-light_brown px-8 py-4">
                    <CheckoutSummary/>
                  </div>
                </>
            );
        } else if (step === STEPS.CHECKOUT) {
            view = (
                <>
                  <CartCompact />
                  <Checkout/>
                </>
            );
        }
    }

    return (
        <div className="flex flex-col lg:flex-row h-full overflow-auto lg:overflow-visible">
          <WidgetProvider
            loading={loading}
            setLoading={setLoading}
            setStep={setStep}
            slug={slug}
            ticketing_base_url={ticketing_base_url}
          >
            {view}
          </WidgetProvider>
        </div>
    );
}
